import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name: "sumField",
})
export class SumFieldPipe implements PipeTransform {

    transform(input: any[], field: string, sumIndices?: boolean[]): number {
        return input?.reduce((acc, val, i) => {
            if (!sumIndices || sumIndices[i]) {
                return acc + val[field]
            } else {
                return acc
            }
        }, 0)
    }

}

@Pipe({
    name: "filterVals",
})
export class FilterValsPipe implements PipeTransform {
    transform(input: any[], value: any): any[] {
        return input.filter((val, i) => val == value)
    }
}

@Pipe({
    name: "filterPropGreater",
})
export class FilterPropGreaterPipe implements PipeTransform {
    transform(input: any[], prop: string, value: any): any[] {
        return input.filter((val, i) => val[prop] > value)
    }
}

@Pipe({
    name: "filterPropLesser",
})
export class FilterPropLesserPipe implements PipeTransform {
    transform(input: any[], prop: string, value: any): any[] {
        return input.filter((val, i) => val[prop] < value)
    }
}

@Pipe({
    name: "filterPropVals",
})
export class FilterPropValsPipe implements PipeTransform {

    transform(input: any[], prop: string, value: any): any[] {
        return input.filter((val, i) => val?.[prop] == value)
    }

}

@Pipe({
    name: "filterHasProp",
})
export class FilterHasPropPipe implements PipeTransform {

    transform(input: any[], prop: string, includeIndices?: boolean[]): any[] {
        return input.filter((val, i) =>  (!includeIndices || includeIndices[i]) && val[prop] )
    }

}

@Pipe({
    name: "filterNotEmpty",
})
export class FilterNotEmptyPipe implements PipeTransform {

    transform(input: any[]): any[] {
        return input.filter((val, i) => val?.length > 0)
    }

}

@Pipe({
    name: "filterNotBlank",
})
export class FilterNotBlankPipe implements PipeTransform {

    transform(input: any[], includeIndices?: boolean[]): any[] {
        return input.filter((val, i) => (!includeIndices || includeIndices[i]) && val)
    }

}